export default "__VITE_ASSET__6z2ptLJD__"